export const DB_DATE_FORMAT = 'YYYY-MM-DD' as const;
export const MOBILE_PLACEHOLDER = '+8801xxxxxxxxx' as const;
export const EMAIL_PLACEHOLDER = 'name@gmail.com' as const;
export const DB_TIME_FORMAT = 'HH:mm:ss' as const;
export const DATE_TIME_FORMAT = 'YYYY-MM-DD hh:mm A' as const;
export const DATE_TIME_PLACEHOLDER = 'dd/mm/yyyy, --:-- --' as const;
export const TIME_FORMAT = 'h:mm A' as const;
export const DATE_FORMAT: string = 'DD/MM/YYYY' as const;
export const DATE_PLACEHOLDER = 'dd/mm/yyyy' as const;
export const PLACEHOLDER_IMG = '/images/placeholder.png';

export const EMPLOYEE_TYPES = [
  { value: 'full-time', label: 'Full Time' },
  { value: 'part-time', label: 'Part Time' },
  { value: 'Contract', label: 'Contract' },
];

export const WEEK_DAYS_OPTIONS = [
  { label: 'Sunday', value: 'Sunday' },
  { label: 'Monday', value: 'Monday' },
  { label: 'Tuesday', value: 'Tuesday' },
  { label: 'Wednesday', value: 'Wednesday' },
  { label: 'Thursday', value: 'Thursday' },
  { label: 'Friday', value: 'Friday' },
  { label: 'Saturday', value: 'Saturday' },
];
export const GENDER_OPTIONS = [
  { label: 'Male', value: 'male' },
  { label: 'Female', value: 'female' },
];

export const BLOOD_GROUP_OPTIONS = [
  { label: 'A+', value: 'A+' },
  { label: 'A-', value: 'A-' },
  { label: 'B+', value: 'B+' },
  { label: 'B-', value: 'B-' },
  { label: 'O+', value: 'O+' },
  { label: 'O-', value: 'O-' },
  { label: 'AB+', value: 'AB+' },
  { label: 'AB-', value: 'AB-' },
];
